"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";

/**
 * Root App Router error boundary. Replaces the root layout when it fails,
 * so keep this self-contained (no Providers / Locale).
 */
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* App Router does not expose HTTP status codes here. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
